
    <span matTooltip="{{description}}" *ngIf="shouldShowNewFeature" class="mr-3">
      <i class="fas fa-star-exclamation"></i>
    </span>
  